mutation CorporateWorkgroupUpdate($input: CorporateWorkgroupUpdateInput!) {
  corporateWorkgroupUpdate(input: $input) {
    corporateWorkgroup {
      id
      _rowTimestamp
      _isUpdatable
      _isDeletable
      workgroupNumber
      name
      description
      businessUnitId
      corporateChartOfAccount {
        id
      }
      productionPhaseId
      isNewWorkgroupSelectable
      prefixCode
      statusType {
        statusType
      }
    }
  }
}
